import axios from 'axios';

let baseURL = process.env.REACT_APP_NEW_URL;

if (!baseURL) {
    baseURL = "https://master.bintix.com/node/new/api"
}

const instance = axios.create({
    baseURL,
    headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
    },
});

instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.clear();
            window.location.reload();
        }

        return Promise.reject(error);
    }
);

export default instance;